import useUserHasPermissions from './useUserHasPermissions';

export const useHasSurgeonsPermission = () => {
  const { isLoading, hasPermissions } = useUserHasPermissions({ permissions: ['surgeons:read'] });

  return {
    isLoading,
    data: hasPermissions,
  };
};
